import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { InterceptorSkipHeader } from './http.interceptor.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  noContentType = { headers: new HttpHeaders({ noContentType: 'True' }) };

  progress: number;
  response: any;

  constructor(private http: HttpClient) { }

  private uploadedEvent = new BehaviorSubject(false);
  currentUploadEvent = this.uploadedEvent.asObservable();

  changeUploadEvent(flag){
    this.uploadedEvent.next(flag);
  }

  get(url: string): Observable<any> {
    return this.http
      .get(url)
      .pipe(map(res => <any>res));
  }

  post(url: string, model: any) {
    const body = JSON.stringify(model);
    return this.http
      .post(url, body)
      .pipe(map((response: Response) => <any>response));
  }

  // For Post upload
  upload(url: string, formData: any): Observable<any> {
    const headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    // return this.http.post(url, formData, { headers, reportProgress: true, observe: "events" });
    const upload = new HttpRequest('POST', url, formData, {reportProgress: true, headers: headers});
    this.http.request(upload).subscribe((event) => {
      if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(100 * event.loaded / event.total);
          (<HTMLInputElement>document.getElementById('progressBar')).value = String(Math.round(this.progress));
          if(this.progress === 100){
            this.changeUploadEvent(true);
          } else {
            this.changeUploadEvent(false);
          }
      }
      else if (event.type === HttpEventType.Response) {
         this.response = event;
      }
  });

  return this.response;
  }


  postEmailFormData(url: string, model: any) {
    const headers = new HttpHeaders().set(InterceptorSkipHeader, 'true');
    return this.http
      .post(url, model, this.noContentType)
      .pipe(map((response: Response) => <any>response));
  }
}
